module.exports = __webpack_public_path__ + "img/stock2.0a7b961a.png";